import type {PartialGlAccount, ReportRowKind, RowWarning} from "../../types/types.ts";
import {RowWarningTag} from "../StatementTable/RowWarningTag.tsx";
import {COL_SEP_R, levelPadding, stickyCellBg} from "./tableStyles.ts";

interface AccountLabelCellProps {
    row: {kind: ReportRowKind; level: number; account: PartialGlAccount | null; warning: RowWarning | null};
    label: string;
    currency: string;
    expandable: boolean;
    expanded: boolean;
    drillable: boolean;
    showKpiBadge?: boolean;
    isImbalanced?: boolean;
}

export function AccountLabelCell({
    row,
    label,
    currency,
    expandable,
    expanded,
    drillable,
    showKpiBadge = false,
    isImbalanced = false,
}: AccountLabelCellProps) {
    const code = row.account?.code ?? null;
    return (
        <td
            className={`sticky left-0 z-20 px-3 py-2 ${COL_SEP_R} ${stickyCellBg(row, isImbalanced)} ${levelPadding(row.level)}`}
        >
            <div className="flex items-center justify-between gap-3 min-w-0">
                <div className="flex items-center min-w-0">
                    {expandable && (
                        <span className="mr-1.5 w-3 text-[11px] text-gray-500">
                            {expanded ? "▾" : "▸"}
                        </span>
                    )}
                    <div className="flex items-center flex-wrap min-w-0">
                        {code && (
                            <span className="mr-1.5 text-[11px] font-mono text-gray-500">{code}</span>
                        )}
                        <span className="truncate">{label}</span>
                        {row.warning && <RowWarningTag />}
                        {showKpiBadge && (
                            <span className="ml-2 rounded bg-[#DCEEFB] px-1.5 py-0.5 text-[9px] font-bold uppercase tracking-wide text-[#1E6FA8]">
                                KPI
                            </span>
                        )}
                        {drillable && (
                            <span className="ml-2 hidden items-center gap-0.5 text-[9px] font-medium text-[#1E8AD1] group-hover:inline-flex">
                                Bronnen ›
                            </span>
                        )}
                    </div>
                </div>
                <span className="shrink-0 text-[10px] text-gray-400">{currency}</span>
            </div>
        </td>
    );
}
